//Live
export const BASE_URL_LIVE = "https://fivestar-admin-api.ondemandcreations.com";
export const API_URL_LIVE = "https://fivestar-admin-api.ondemandcreations.com";
export const MOBILE_URL_LIVE = "https://fivestar-api.ondemandcreations.com";
export const FRONTEND_URL_LIVE = "https://quote.fivestaruniverse.net";

// Stagging
export const BASE_URL_STAGGING =
  "https://fivestarstagging-apiad.ondemandcreations.com";
export const API_URL_STAGGING =
  "https://fivestarstagging-apiad.ondemandcreations.com";
export const MOBILE_URL_STAGGING =
  "https://fivestarstagging-api.ondemandcreations.com";
export const FRONTEND_URL_STAGGING =
  "https://quote-staging.fivestaruniverse.net";

export const BASE_URL =
  process.env.REACT_APP_MODE === "live" ? BASE_URL_LIVE : BASE_URL_STAGGING;
export const API_URL =
  process.env.REACT_APP_MODE === "live" ? API_URL_LIVE : API_URL_STAGGING;
export const MOBILE_URL =
  process.env.REACT_APP_MODE === "live" ? MOBILE_URL_LIVE : MOBILE_URL_STAGGING;
export const FRONTEND_URL =
  process.env.REACT_APP_MODE === "live"
    ? FRONTEND_URL_LIVE
    : FRONTEND_URL_STAGGING;

export const API_VERSION = "/api/v1";

// COMMON CONSTANT
export const API_TOKEN = localStorage.getItem("user_id");
export const EMAIL_REGEX = /^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/;
export const PASS_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const PASS_VALIDATION_MSG =
  "password should be at least 8 characters, one uppercase, lowercase, special character, numeric value.";

// AUTH URL
export const API_LOGIN = "/company/login";

// DASHBOARD
export const DASHBOARD = "/company/getDashboardList";
export const API_GET_GRAPH_URL = "/admin/graph";

// Drivers URLs
export const API_GET_DRIVERS_BY_FILTER = "/company/getCompanyDriverWithFilter/";
export const API_GET_DRIVERS_BY_ID = "/drivers/getDriverById/";
export const API_ADD_DRIVER = "/drivers/addDriver/";
export const API_EDIT_DRIVER = "/drivers/editDriverProfile/";
export const API_DELETE_DRIVER = "/drivers/deleteDriver/";

// Dumpster URLs
export const API_GET_DUMPSTER_REQUESTED_FILTER =
  "/dumpster/getCompanyRequestWithFilter/";
export const API_GET_DUMPSTER_COMPLETED_FILTER =
  "/dumpster/getCompanyCompletedRequestWithFilter/";
export const API_GET_DUMPSTER_BY_ID = "/dumpster/getDumpsterById/";
export const API_ASSIGN_DUMPSTER_TO_DRIVER = "/dumpster/assignRequestToDriver/";
export const API_UPDATE_DUMPSTER_STATUS = "/dumpster/updateDumpsterStatus/";
export const API_ACCEPT_DUMPSTER_REQUEST = "/dumpster/acceptDumpsterRequest/";
export const API_REJECT_DUMPSTER_REQUEST = "/dumpster/rejectDumpsterRequest/";
export const API_UPDATE_PROVIDER_NOTE =
  "/dumpster/updateDumpsterProviderNoteById/";

// Chat Apis
export const API_GET_CHAT_NOTIFICATIONS =
  "/notification/getCompanyOrderNotificationWithFilter";
export const API_UPDATE_NOTIFICATIONS =
  "/notification/updateCompanyNotificationStatus";
export const API_GET_CHAT = "/adminChat/getAdminChatHistoryById";
export const API_SEND_CHAT_MSG = "/adminChat/addChat";

export const API_CHAT_WINDOW_CLOSE = "/adminChat/companyOfflineChatWindow";
// Dumpster material URLs
export const API_GET_ALL_DUMPSTER_MATERIAL =
  "/dumpster/getDumpsterMaterialSizeWithFilter/";
export const API_GET_DUMPSTER_MATERIAL_BY_ID =
  "/dumpster/getCompanyDumpsterMaterial/";
export const API_EDIT_DUMPSTER_MATERIAL =
  "/dumpster/updateCompanyDumpsterMaterial/";

// Settings
export const API_GET_COMAPNY_PROFILE = "company/getCompanyById/";
export const API_UPDATE_COMAPNY_PROFILE = "/company/updateCompany/";
export const API_GET_COMAPNY_BANK_DETAILS = "/company/getCompanyAccountDetail/";
export const API_UPDATE_COMAPNY_BANK_DETAILS =
  "/company/addCompanyAccountDetail/";
export const API_UPDATE_COMAPNY_PASSWORD = "/company/changePassword/";

export const API_GET_COMPANIES_URL = "/company/getCompany/";
export const FILE_UPLOAD = "/company/FILE_UPLOAD/";

// API-PROVIDER

export const ADD_DUMPSTER_PROVIDER =
  "/dumpster/addDumpsterProviderNotesFileById/";
